
import {
  Component, Mixins,
} from 'vue-property-decorator';
import moment from 'moment';
import AttachmentsList from '@/components/AttachmentsList.vue';
import TaskStatusAlert from '@/components/TaskStatusAlert.vue';
import TaskActions from '@/components/TaskActions.vue';
import DatePickerDialog from '@/components/DatePickerDialog.vue';
import {
  currentUserIsRequester,
  currentUserIsSuper,
} from '@/helpers';
import TaskMixin from '@/mixins/TaskMixin.vue';
import UtilsMixin from '@/mixins/UtilsMixin.vue';

moment.locale('it');

@Component({
  components: {
    AttachmentsList,
    TaskStatusAlert,
    TaskActions,
    DatePickerDialog,
  },
})
export default class TaskS extends Mixins(TaskMixin, UtilsMixin) {
  datePickerDialog = false
  datePickerDate: string | null = null
  datePickerName: string | null = null

  siteInspectionDate: Date | null = null
  notes: string | null = null

  // Aggiorna i campi con gli eventuali nuovi valori della Lead selezionata
  refreshTask() {
    console.log(`${this.constructor.name}: refreshTask()`); // eslint-disable-line no-console

    this.siteInspectionDate = this.selectedLead?.step2SiteInspectionDate ?? null;
    this.notes = this.selectedLead?.step2Notes ?? null;

    // Richiama il metodo implementato nel mixin
    return this.mixinRefreshTask();
  }

  get isSuper(): boolean { return currentUserIsSuper(); }

  get isRequester(): boolean { return currentUserIsRequester(); }

  // Decide se mostrare l'allegato di tipo 'sopralluogoTecnico'
  get isSiteInspectionFormVisible() {
    if (!this.selectedLead) return false;

    // Super utenti, richiedenti e chiunque se lo stato della lead è 'new'
    // possono vedere l'allegato
    if (this.isSuper || this.isRequester) return true;
    if (this.leadStatus === 'new') return false;

    // In tutti gli altri casi, lo mostra soltanto nelle figlie
    return this.leadType && ['installatore-figlia', 'elettrica-figlia', 'termica-figlia'].includes(this.leadType);
  }

  onClickDate(name: string) {
    console.log(`${this.constructor.name}: onClickDate(${name})`); // eslint-disable-line no-console

    if (this.leadStatus !== 'open'
      || this.taskStatus !== null
      || this.readonly) return;

    // Imposta per quale campo verrà utilizzato il DatePicker
    this.datePickerName = name;

    // Imposta l'eventuale data precedentemente selezionata
    this.datePickerDate = this[name]
      ? moment(this[name]).toISOString(true).substring(0, 10)
      : null;

    // Apre il dialog per la selezione della data
    this.datePickerDialog = true;
  }

  onClearDate(name: string) {
    console.log(`${this.constructor.name}: onClearDate(${name})`); // eslint-disable-line no-console

    if (this.leadStatus !== 'open') return;

    const update = {} as { [key: string]: unknown };

    // Cancello la data nel modulo e nel prossimo aggiornamento
    if (name in this) {
      this[name] = null;
      update[name] = null;
    }

    // Modifico eventuali campi collegati
    switch (name) {
      default:
        break;
    }

    // Valido il modulo con le nuove informazioni inserite
    this.onValidate('completed');

    this.$store.dispatch('updateTaskFields', update);
  }

  onSelectDate(date: string | null) {
    console.log(`${this.constructor.name}: onSelectDate() date =`, date); // eslint-disable-line no-console

    if (!this.datePickerName) return;

    // Chiudo il dialog per la selezione della data
    this.datePickerDialog = false;

    const update = {} as { [key: string]: unknown };

    // Trasforma in un valore di tipo Date prima di restituirlo
    const selectedDate = date
      ? moment(date, 'YYYY-MM-DD').toDate()
      : null;

    // Inserisco la data nel modulo e nell'aggiornamento
    if (this.datePickerName in this) {
      this[this.datePickerName] = selectedDate;
      update[this.datePickerName] = this[this.datePickerName];
    }

    // Resetto eventuali switch collegati
    switch (this.datePickerName) {
      default:
        break;
    }

    // Valido il modulo con le nuove informazioni inserite
    this.onValidate('completed');

    this.$store.dispatch('updateTaskFields', update);
  }

  // Effetta la validazione del modulo
  async onValidate(status: 'completed' | 'error') {
    console.log(`${this.constructor.name}: onValidate(${status})`); // eslint-disable-line no-console

    // Sceglie se validare il modulo per un completamento o per un fallimento
    this.selectedStatus = status;

    // Avvia l'effettiva validazione
    const form = this.$refs.form as Vue & {
      validate: () => boolean;
      reset: () => boolean;
    };

    if (form) {
      const result = form.validate();
      console.log(`${this.constructor.name}: onValidate() form.validate() =`, result); // eslint-disable-line no-console
    } else {
      console.error(`${this.constructor.name}: onValidate() form =`, form); // eslint-disable-line no-console
      console.error(`${this.constructor.name}: onValidate() this.$refs =`, this.$refs); // eslint-disable-line no-console
    }

    return Promise.resolve();
  }
}
